import { InvoiceHistoryTable } from '../cards/InvoiceHistoryTable';

export const InvoiceHistorySection = () => {
    return (
        <section className="settings-section">
            <div className="settings-section-header">
                <div>
                    <h2 className="settings-section-title">Billing History</h2>
                    <p className="settings-section-subtitle">Past invoices and payment receipts</p>
                </div>
            </div>
            <div className="settings-section-body">
                <InvoiceHistoryTable />
            </div>
        </section>
    );
};
